<mat-accordion *ngIf="data?.specs.especificaciones.length > 0">
    <mat-expansion-panel [expanded]="true" (opened)="panelOpenState = true" (closed)="panelOpenState = false">
        <mat-expansion-panel-header>
            <mat-panel-title>
                <span class="icon_specs">
                    <img src="./assets/img/icon_{{data.title}}.svg" alt="icon_{{data.title}"/>
                </span>
                {{ summaryService.getTitleSpecs(data.title) | titlecase }}
            </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="text-specs" *ngFor="let specs of data.specs.especificaciones">
            <span *ngFor="let spec of specs.split(':')" [innerHTML]="spec" > </span>
        </p>
    </mat-expansion-panel>
</mat-accordion>
